import { universeDefaults } from "@ptp/look";

/**
 * Live values of the background universe. Mutable so the ?tweak=1 panel can change them;
 * nothing else writes them. Defaults are the projection's, from @ptp/look.
 */
export const universeTuning = {
  speed: universeDefaults.speed as number,
  flow: universeDefaults.flow as number,
  opacity: universeDefaults.opacity as number,
  size: universeDefaults.size as number,
  haze: universeDefaults.haze as number,
  twinkle: universeDefaults.twinkle as number,
  glint: universeDefaults.glint as number,
};
